<template>
  <b-field
    :label="ilabel"
    :type="{ 'is-danger': errors.has('tags') }"
    :message="errors.first('tags')"
  >
    <p class="control">
      <slot name="iconleft" />
    </p>
    <b-taginput
      name="tags"
      ref="tagsInput"
      v-model="buffer"
      :data="filteredTags"
      :allow-new="false"
      :before-adding="beforeAdding"
      :disabled="disabled"
      :placeholder="iplaceholder"
      group-field="name"
      group-options="tags"
      field="name"
      expanded
      rounded
      autocomplete
      append-to-body
      v-validate="{
        required: required,
        only1PerCategory: only1PerCategory
      }"
      :open-on-focus="true"
      icon="caret-right"
      @input="$emit('input', buffer)"
      @typing="getFilteredTags"
    >
      <template #selected="props">
        <my-tag
          v-for="(tag, index) in props.tags"
          :key="index"
          :tag="tag"
          :color="tag.color"
          :closable="!disabled"
          @close="removeTag(index, $event)"
        />
      </template>
      <template #empty>
        {{ $t('compCoreTagsInput.no-tags') }}
      </template>
    </b-taginput>
  </b-field>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { Tag } from '@/models/core/TagCategory.js'
import { useAdminStore } from '@/stores/admin.js'
import { useAuthenticationStore } from '@/stores/authentication.js'

import _ from 'lodash'

export default {
  name: 'TagsInput',
  inject: ['$validator'],
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    tagCategories: {
      type: Array,
      default: function () {
        return []
      }
    },
    addUntagged: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    only1PerCategory: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  setup () {
    const adminStore = useAdminStore()
    const authStore = useAuthenticationStore()
    return { adminStore, authStore }
  },
  components: {
    'my-tag': () => import('@/components/core/MyTag.vue')
  },
  data () {
    return {
      buffer: Object.assign([], this.value),
      filteredTags: []
    }
  },
  computed: {
    ilabel: function () {
      let label = this.$t('tags')
      if (this.label !== null) {
        label = this.label
      }
      return label
    },
    iplaceholder: function () {
      let placeholder = this.$t('add')
      if (this.placeholder) {
        placeholder = this.placeholder
      }
      return placeholder
    },
    itagCategories: function () {
      if (this.tagCategories.length > 0) {
        return this.tagCategories
      } else {
        return this.adminStore.allTagCategories
      }
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = Object.assign([], this.value)
      }
    }
  },
  methods: {
    beforeAdding (tag) {
      let toadd = this.buffer.filter((obj) => obj.id === tag.id).length === 0
      // Remove values of the same category
      if (toadd && this.only1PerCategory) {
        let index = this.buffer.findIndex((obj) => {
          return obj.category === tag.category
        })
        if (index >= 0) {
          this.$refs.tagsInput.removeTag(index)
        }
      }
      return toadd
    },
    removeTag (index, event) {
      this.$refs.tagsInput.removeTag(index, event)
    },
    getFilteredTags: function (text) {
      this.filteredTags = _.cloneDeep(this.itagCategories)
      this.filteredTags = this.filteredTags.map((obj) => {
        obj.tags = obj.tags.filter((option) => {
          return (
            option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >=
            0
          )
        })
        if (this.addUntagged) {
          // Add untagged tag
          obj.tags.push(
            Tag.createFromObj({
              id: uuidv4(),
              name: Tag.UNTAGGED_LABEL,
              color: obj.color,
              category: obj.id
            })
          )
        }
        return obj
      })
    }
  },
  created () {
    let self = this
    this.$validator.extend('only1PerCategory', {
      getMessage: (field) => self.$t('compCoreTagsInput.error-1'),
      validate: (value, args) => {
        let categories = value.map((obj) => obj.category)
        return Array.from(new Set(categories)).length === categories.length
      }
    })
  },
  mounted () {
    if (this.authStore.isAuthenticated) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })
      this.adminStore
        .getAllTagCategories()
        .then((data) => {
          this.getFilteredTags('')
          loadingComponent.close()
        })
        .catch((error) => {
          loadingComponent.close()
          throw error
        })
    } else {
      this.getFilteredTags('')
    }
  }
}
</script>

<style>
a.dropdown-item {
  padding-left: 30px;
}
</style>
